// import $models from '@/models'
// import $store from '@/store'
import $registry from "@/generic_api/lib/generic_store/loader/registry"

/* =========================== Helper functions ============================= */

export function set_ready( name, ready = true) {

  const ALLOWED_GLOBAL_READY_FLAGS = [
    'auth',
    'user',
    'goals',
    'commitments',
    'tasks',
    'timeslot_collections',
    'optimizer_worker',
    'timeslot_worker',
    'optimizer_input',
    'recorded_sessions',
  ];

  if ( ALLOWED_GLOBAL_READY_FLAGS.includes( name )
    || name.startsWith('goal:')
    || name.startsWith('tasks:') ) {

    $registry.commit('SET_GLOBAL_READY_STATE', {
      name: name,
      value: ready
    })

  } else {
    throw new Error('set_ready: name not allowed ' + name)
  }

  // console.log("******", name, "is ready ******")
}

export function rem_ready( name ) {
  $registry.commit('REM_GLOBAL_READY_STATE', { name: name })
}

export function mapReady( ...args ) {
  let map = {}
  args.forEach(name => {
    map['$ready_' + name] = function mappedGetter () {
      return $registry.getters.is_ready( name )
    }
  })
  return map
}

export function get_ready(name, id = null) {
  // Should be reactive...
  if ( id ) {
    name = name + ':' + id
  }
  // TODO: Why not return function directly?
  return $registry.getters.is_ready(name);
}

export function get_ready_count(name) {
  return Object.keys($registry.state.ready).filter(entry => {
    return entry.startsWith( name + ':' )
  }).length
}

export function get_registry() {
  return $registry;
}

export function get_registry_state() {
  return $registry.state;
}

// export function registry_reset() {}
